import {
  Bookmark,
  Bug,
  CalendarDays,
  CircleAlert,
  Clock,
  Eye,
  Flag,
  Flame,
  Heart,
  Inbox,
  ListChecks,
  Rocket,
  Sparkles,
  Star,
  Target,
  Users,
  Zap,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

/** Icons a saved view can wear; the key is what's stored in `icon`. */
export const VIEW_ICONS: Record<string, LucideIcon> = {
  bookmark: Bookmark,
  flame: Flame,
  star: Star,
  bug: Bug,
  zap: Zap,
  target: Target,
  flag: Flag,
  alert: CircleAlert,
  inbox: Inbox,
  clock: Clock,
  calendar: CalendarDays,
  users: Users,
  checks: ListChecks,
  rocket: Rocket,
  eye: Eye,
  sparkles: Sparkles,
  heart: Heart,
}

export const DEFAULT_VIEW_ICON = 'bookmark'

export function viewIconFor(icon: string | null | undefined): LucideIcon {
  return (icon ? VIEW_ICONS[icon] : undefined) ?? Bookmark
}

export function ViewIcon({
  icon,
  className,
}: {
  icon: string | null | undefined
  className?: string
}) {
  const Icon = viewIconFor(icon)
  return <Icon className={cn('size-3.5 shrink-0', className)} aria-hidden />
}
